module.exports = __webpack_public_path__ + "img/eye.d0882264.svg";